// Catering Item Category Enum
export enum CateringItemCategory {
  FOOD = 'Food',
  BEVERAGES_NON_ALCOHOLIC = 'Beverages – Non-Alcoholic',
  ALCOHOL = 'Alcohol',
  PLATTERS_PARTY_TRAYS = 'Platters / Party Trays',
  CUSTOM_ITEMS_SPECIAL_REQUESTS = 'Custom Items / Special Requests',
  ADD_ONS_UPGRADES = 'Add-ons / Upgrades',
  DISPOSABLE_PACKAGING = 'Disposable Packaging',
  TABLEWARE_CUTLERY = 'Tableware / Cutlery',
}

export interface ICateringOrderItem {
  id: number;
  cateringOrderId: string;
  description: string;
  quantity: number;
  category: CateringItemCategory;
  unitPrice: number;
  createdAt: Date;
  updatedAt: Date;
}
export interface LineItem {
  id: number | null;
  description: string;
  quantity: number;
  unitPrice: number;
  category: CateringItemCategory;
  packageId: number | null;
}
